module.exports = __webpack_public_path__ + "static/media/8.110cdea7.jpg";